let React               = require("react");

let LoginUtil           = require("../../util/LoginUtil.js");
let HubsUtil            = require("../../util/HubsUtil.js");
let Utilities           = require("../../util/Utilities.js");
let ContentServerClient = require("../../ContentServerClient.js");
let ApplicationContext  = require("../../config/ApplicationContext.js");
let ObservableUtil      = require("../../util/ObservableUtil.js")

let HubModalManager     = require("../../controls/hub/modals/HubModalManager.jsx");
let MasterPage          = require("../generic/MasterPage.jsx");
let RouterHubs          = require("../../controls/hub/router/RouterHubs.jsx");

class DataHubPage extends React.Component {
    constructor() {
        super()
        this.state = {

            // defualt everything to null so my rendering can easily
            // tell if it has been loaded or not.
            loadingHubName: "",
            currentHub: null,
            currentHubMembers: null,
            currentHubInvites: null,

            myHubs: null,
            memberHubs: null,
            trashHubs: null,

            hubInvites: null,

            allowedNumberOfHubs: -1,
            currentNumberOfHubs: -1,

            errorListHubs: false
        };


        this.getUserHubs = this.getUserHubs.bind(this);
        this.setHandlers = this.setHandlers.bind(this);
        this.removeHandlers = this.removeHandlers.bind(this);
        this.loadMembersAndInvites = this.loadMembersAndInvites.bind(this);
        this.exceptionGettingListHubs = this.exceptionGettingListHubs.bind(this);
        this.exceptionGettingHubData = this.exceptionGettingHubData.bind(this);

        this.lastHubId = -1;
    }

    componentDidMount() {
        LoginUtil.checkLogin(()=> {
            ContentServerClient.loginCheck(this.props.handleError)
                .then(info => {
                    this.setState({ typeUser: HubsUtil.typeUser(info.entitlements)})
                    this.getUserHubs(this.props);
                })
        }, this.props.handleError);

        ObservableUtil.subscribeToAction("addMargin", "", "margin", this.addMarginContent)
    }

    componentWillUnmount(){
        ObservableUtil.unsubscribeToAction("addMargin", "", "margin");
        //the authorized user is going to be redirected, as a result, there are not "currentHub.id"
        if(this.state.currentHub){
            this.removeHandlers(this.state.currentHub.id);
        }
    }

    setHandlers(hub){
        ObservableUtil.subscribeToChange("addMember", hub.id, "manageMembers", res => { if (res && res.invites) { this.loadMembersAndInvites(hub) }});
        ObservableUtil.subscribeToChange("transferring", hub.id, "hubs", () => this.loadMembersAndInvites(hub));
        ObservableUtil.subscribeToChange("deleteMember", hub.id, "manageMembers", res => {  if(res && res.isOwnEntry){this.redirectToDefaultHub(hub)}
                                                                                            else{this.loadMembersAndInvites(hub)}
                                                                                        });
        ObservableUtil.subscribeToChange("cancelTransferring", hub.id, "hubs", () => this.loadMembersAndInvites(hub));
        ObservableUtil.subscribeToChange("cancelInvitation", hub.id, "manageMembers", () => this.loadMembersAndInvites(hub));
    }

    removeHandlers(hubID){
        ObservableUtil.unsubscribeToChange("addMember", hubID, "manageMembers");
        ObservableUtil.unsubscribeToChange("transferring", hubID, "hubs");
        ObservableUtil.unsubscribeToChange("deleteMember", hubID, "manageMembers");
        ObservableUtil.unsubscribeToChange("cancelTransferring", hubID, "hubs");
        ObservableUtil.unsubscribeToChange("cancelInvitation", hubID, "manageMembers");
    }

    loadMembersAndInvites(hub){
        // make the other requests that required knowing the current hub id concurrently.
        ContentServerClient.getMembersHub(this.props.handleError, hub.id)
        .then(currentHubMembers =>{
            this.props.setHubInfo(null, currentHubMembers.members, null, null);
            this.setState({currentHubMembers: currentHubMembers.members})
        })

        if(HubsUtil.isOwner(hub)){
            ContentServerClient.getInvitesHub(this.props.handleError, hub.id)
            .then(currentHubInvites =>{
                this.props.setHubInfo(null, null, currentHubInvites.invites, null);
                this.setState({currentHubInvites: currentHubInvites.invites})
            })
        }else{
            //clean up the previous list of invitations
            this.props.setHubInfo(null, null, [], null);
        }
    }

    //if the user is a member of a hub and decided removed himself, he is going to be redirected to the default hub, it is not necessary to request the old hub
    redirectToDefaultHub(oldHub){
        let {id, name} = this.state.defaultHub;

        this.props.onClose("manage")
        this.props.onOpenToast("memberRemoved", {hubName: oldHub.name})
        this.props.history.push(`/hubs/${id}-${encodeURIComponent(name)}/libraries`)
    }

    getId(pathname){
        return HubsUtil.getHubId(pathname);
    }

    getName(pathname){
        return HubsUtil.getHubName(pathname);
    }

    componentWillReceiveProps(nextProps){
        const {history, location: {pathname}} = this.props;

        let newId = this.getId(nextProps.location.pathname);
        let oldId = this.getId(pathname);

        let newPath = HubsUtil.handleString(nextProps.location.pathname);//
        let newName = newPath.sliceTo(newPath.lastSearch("/"));
        let oldPath = HubsUtil.handleString(pathname);
        let oldName = oldPath.sliceTo(oldPath.lastSearch("/"));
        let hasSearch = nextProps.location.search !== "";

        //this validation avoid sending an unnecessary request about the user's hub when he is changing tabs or open modals
        if(history.action === "PUSH" && pathname !== "/start" && pathname !== "/hubs" &&
            (newId !== oldId || (newId === oldId && newName !== oldName) || (hasSearch)) &&
            (history.location.state === undefined || (history.location.state && history.location.state.modal !== true))){
            this.getUserHubs(nextProps);
        }
    }

    getUserHubs(props){

        let pathname = props.location.pathname;
        let handleError = props.handleError;

        let hubId = null;
        let hubName = null;

        // clear the data from the last hub
        this.setState({
            loadingHubName: hubName || "",
            currentHub: null,
            currentHubMembers: null,
            currentHubInvites: null
        });

        if(this.lastHubId != -1) this.removeHandlers(this.lastHubId);


        // this is not dependent on the current hub being loaded.  Run right away.
        ContentServerClient.getMemberofHubs(handleError)
            .then(memberHubs =>{
                this.setState({memberHubs: memberHubs.hubs})
            })
            .catch(this.exceptionGettingListHubs)

        let getHubDataFromUrl = Promise.resolve();

        // if we already have a hub id in the url, load that hub right away
        if(pathname !== "/start" && pathname !== "/hubs" && pathname !== "/hubs/"){
            hubId = this.getId(pathname);
            hubName = this.getName(HubsUtil.getRealPathname(location.href));

            this.setState({loadingHubName: hubName});

            getHubDataFromUrl = ContentServerClient.getHub(handleError, hubId, hubName)
                                    .then(hub => {
                                        this.setState({currentHub: hub});
                                        this.loadDataAfterHub(hub, props);
                                    })
                                    .catch(error => this.exceptionGettingHubData(error, hubId))
        }

        // whether or not we loaded the current hub already,
        // make the call to load all hub informaton. after the promise resolves
        getHubDataFromUrl
            .then(()=>{
                return ContentServerClient.getOwnerHubs(handleError);
            })
            .then(hubInfo => {
                this.setHubInfo(props, hubInfo, hubId !== null);
            })
            .catch(this.exceptionGettingListHubs)
    }

    // set the necessary info after getting all the hub data.
    // if current hub has not been set, set it.  If no hubs exist
    // may need to create one.
    setHubInfo(props, hubInfo, currentAlreadyLoaded){
        this.setState({
                myHubs: hubInfo.hubs,
                trashHubs: hubInfo.trash.hubs,
                defaultHub: HubsUtil.getDefaultHub(hubInfo.hubs),
                allowedNumberOfHubs: hubInfo.allowedNumberOfHubs,
                currentNumberOfHubs: hubInfo.count
            },
            // TODO clean this up (below). we should have to send this data upward if we
            // didn't have these managers with hub specific stuff.
            () => {
                // for toast page
                this.props.setCanHaveMoreHubs(this.canHaveMoreHubs(), this.isPremiumAccount(), hubInfo.allowedNumberOfHubs);
                // for modals
                this.props.setHubCounts(hubInfo.allowedNumberOfHubs, hubInfo.count);
            }
        );



        // if the hubID has already been set, it got loaded above directly from the url.
        // no more work necessary
        if(currentAlreadyLoaded) return;

        // if it has not been set, see if we need to create a new one
        if(hubInfo.count > 0){
            // if not, just pick the first hub
            let hub = hubInfo.hubs[0];
            //hubId = hub.id;
            this.setState({currentHub: hub});
            this.loadDataAfterHub(hub, props);

        } else {
            // or else we need to create a new hub
            let newHubName = ApplicationContext.getUserData().firstName;
            ContentServerClient.createHub(handleError, newHubName)
            .then(hub => {
                // set the new hub
                //hubId = hub.id;
                this.setState({currentHub: hub});
                this.loadDataAfterHub(hub, props);
            });
        }
    }

    // load the data that can be loaded about a current hub
    // after the hub has been loaded.
    loadDataAfterHub(hub, props){
        let history = props.history;
        let search = props.location.search;
        let tab = (props.location.state)? props.location.state.tab : "";

        this.setHandlers(hub);
        Utilities.setCookie(`lastHubId=${hub.id}`);

        HubsUtil.setUpHubUrl(hub, history, tab);
        props.setHubInfo(hub, null, null, search);

        this.loadMembersAndInvites(hub);
        this.lastHubId = hub.id;
    }

    canHaveMoreHubs() {
        let {allowedNumberOfHubs, currentNumberOfHubs} = this.state;
        return allowedNumberOfHubs > currentNumberOfHubs;
    }

    isPremiumAccount(){
        return /(premium|education)/gi.test(this.state.typeUser);
    }

    exceptionGettingHubData(error, hubInfo){
        this.setState({isLoading: false})
         // if hubID is same as cookie, try loading default hub
        if(Utilities.getCookie("lastHubId") === hubInfo){
            Utilities.setCookie(`lastHubId=`);
            this.props.setError(false);
            this.props.history.push("/start");
        } else {
            this.props.history.push("/start");
            // if hub is not the same as the cookie, show the error.
            // also go back to the default hub.
        }
    }

    exceptionGettingListHubs(error){
        this.setState({isLoading: false, errorListHubs: true})
    }

    render() {
        return  <RouterHubs
                    {...this.state}
                    {...this.props}
                />
    }
}

// TODO need to fix this
module.exports = props => <MasterPage {...props}
                                renderPage={masterPageProps =>
                                    <HubModalManager
                                        {...masterPageProps}
                                        renderPage={addedProps =>
                                            <DataHubPage
                                                {...props}
                                                {...addedProps}
                                                {...masterPageProps}
                                            />
                                        }
                                    />
                                }
                            />
